module.exports = __webpack_public_path__ + "media/landing-page/seta-04688276.png";